import React from 'react';
import { observer } from "mobx-react-lite";
import { useTranslation } from 'react-i18next';
import { MenuCard } from '../menu/MenuCard';
import styled from "styled-components";
import { FaUserCheck } from "react-icons/fa";
import { editorStore } from '../../stores/EditorStore';
import { MenuCardLabel } from '../menu/MenuCardLabel';
import { undoableSetUsername } from '../../stores/undo/operation/SetUsernameOp';
import { currentMapUserListStore } from '../../stores/CurrentMapUserListStore';
import { mainMapEditorStore } from '../../stores/MapEditorStore';
const MapEditorElement = styled.div.withConfig({
  displayName: "MapUserOverview__MapEditorElement",
  componentId: "sc-18bhxgm-0"
})(["margin-left:6px;"]);
export const MapUserOverview = observer(() => {
  const {
    t
  } = useTranslation();
  const {
    username
  } = editorStore;
  const {
    currentMapStore
  } = mainMapEditorStore;
  const {
    hasCurrentMap
  } = currentMapStore;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(MenuCard, null, /*#__PURE__*/React.createElement(MenuCardLabel, null, t("editor.user")), /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("input", {
    type: "text",
    value: username,
    placeholder: t("editor.username"),
    onChange: e => undoableSetUsername(e.target.value)
  }))), hasCurrentMap && currentMapStore.currentMapId === currentMapUserListStore.currentMapId && /*#__PURE__*/React.createElement(MenuCard, null, /*#__PURE__*/React.createElement(MenuCardLabel, null, t("editor.current_map_username_list"), ":"), currentMapUserListStore.currentMapUserList.map(user => /*#__PURE__*/React.createElement(MapEditorElement, {
    key: user.userId
  }, /*#__PURE__*/React.createElement(FaUserCheck, null), "\xA0", user.username))));
});